export function decodeJson<T>(data: string): T | null {
    // This is not a type safe operation
    // There are some ways to deal with this but none officially supported in TS.
    return JSON.parse(data) as T;
}

export function encodeJson<T>(value: T): string {
    return JSON.stringify(value);
}